<template>
  <div>
    <v-delete-dialog
      v-if="showingAlert"
      @close="showingAlert = false"
      @confirm="onRemoveFile"
      @cancel="cancelDelete"
      :errorMessage="errorMessage">
    </v-delete-dialog>
    <d-row>
      <d-col lg="12" >
        <v-feedback :bus="bus"></v-feedback>
      </d-col>
    </d-row>

    <d-row>
      <d-col>
        <h5>Upload Documents</h5>
      </d-col>
    </d-row>

    <d-row class="d-flex" lg="12" >
      <d-col class="align-self-center col-1">
        File
      </d-col>

      <d-col class="col-3">
        <div class="custom-file">
          <input type="file" class="custom-file-input" id="documents" @change="onDocUpload" />
          <label class="custom-file-label" for="documents">
            <span v-if="uploadedDoc.file !== undefined">{{uploadedDoc.file.name}}</span>
            <span v-else>Choose a file...</span>
          </label>
        </div>
      </d-col>
      <d-col class="align-self-center col-1">
        <span>Type</span>
      </d-col>
      <d-col class="col-2">
        <d-select v-model="type">
          <option selected value="Unspecified">Default</option>
          <option value="ChamberOfCommerce">Chamber of Commerce</option>
          <option value="ArticlesOfAssociation">Articles of Association</option>
          <option value="TermsAndConditions">Terms and Conditions</option>
        </d-select>
      </d-col>
      <d-col class="align-self-center col-1">
        <span>Description</span>
      </d-col>
      <d-col class="col-2">

        <d-input v-model="description" />
      </d-col>
      <d-col class="col-2">
        <d-button theme="primary" :disabled="submitting" @click="onSubmit">Upload</d-button>
      </d-col>
    </d-row>

    <d-row class="mt-5">
      <d-col>
        <h5>Overview Documents</h5>
      </d-col>
    </d-row>


    <d-row>
      <d-col class="col-12">
        <d-card >
          <d-card-body class="p-0">
            <table class="table  mb-0">
              <thead class="bg-light">
              <tr>
                <th scope="col" class="border-0"><span>File name</span></th>
                <th scope="col" class="border-0"><span>File type</span></th>
                <th scope="col" class="border-0 text-right"><span>Action</span></th>
              </tr>
              </thead>

              <tbody>
              <template v-for="doc in documents">
                <tr>
                  <td>
                    <d-link :href="doc.file.url" target="_blank"  >{{doc.description}} </d-link>
                  </td>
                  <td>
                    {{doc.type}}
                  </td>
                  <td class="text-right" @click="onDelete(doc.file.id)">
                    <d-link ><i class="fa fa-trash-alt"></i></d-link>
                  </td>
                </tr>
              </template>
              </tbody>
            </table>

          </d-card-body>
        </d-card>

      </d-col>
    </d-row>

  </div>
</template>

<script>
import Vue from 'vue';

export default {
  methods: {

    onDelete: function(id) {
      this.deleteId = id
      this.showingAlert = true;
    },

    onDocUpload: function (event) {
      if (event.target.files.length > 0) {

        this.uploadedDoc = {
          file: event.target.files[0],
          description: this.description,
          type: this.type
        }
      }
    },

    cancelDelete() {
      this.showingAlert = false;

      this.deleteId = null;
    },

    onRemoveFile: async function() {

      let docs = [];

      this.documents.map(doc => {
        if (doc.file.id !== this.deleteId) {
          docs.push({
            id: doc.file.id,
            description: doc.description,
            type: doc.type
          });
        }
      })

      const data = await this.$apollo.mutate({
        mutation: require('~/graphql/parkings/UpdateGeneralInfo.gql'),
        variables: {
          id: this.parking.id,
          documents: docs,
        }
      });

      if (data.data.updateProvider.provider) {
        window.location.reload(true);
      }
    },


    onSubmit: async function (event) {
      event.preventDefault();

      if (this.uploadedDoc.file !== undefined && this.description !== "") {
        this.submitting = true;
        this.uploadedDoc.description = this.description
        this.uploadedDoc.type = this.type

        // Assemble the photos.
        let docs = [];

        this.documents.forEach(doc => {

          if (!doc.enabled) {
            return;
          }

          docs.push({
            id: doc.file.id,
            description: doc.description,
            type: doc.type
          });
        });

        docs.push(this.uploadedDoc)

        const data = await this.$apollo.mutate({
          mutation: require('~/graphql/parkings/UpdateGeneralInfo.gql'),
          variables: {
            id: this.parking.id,
            documents: docs,
          }
        });

        this.submitting = false;

        if (data.data.updateProvider.provider) {
          window.location.reload(true);
        }
      } else {
        this.bus.$emit('submitData', {type: 'warning', message: 'Select a file and add a description!'})
      }

    },

    isDirty: () => false,
  },

  props: {
    parking: {
      required: true,
      type: Object,
    },
  },

  mounted: function () {
    this.documents = this.parking.documents.map(doc => {
      return {
        enabled: true,
        ...doc,
      };
    });
  },

  data: function () {
    return {
      showingAlert: false,
      errorMessage: 'Do you really want to delete this file?',
      deleteId: null,
      bus: new Vue(),
      uploadedDoc: {},
      submitting: false,
      documents: [],
      description: "",
      type: "Unspecified",
    };
  },
};
</script>

